<template>
  <div class="wrap">
    <div class="board_detail">
      <div class="container">
        <div class="board_warp">
          <div class="title_area">
            <!-- <div class="title">{{ contentNotice.title }}</div> -->
            <div class="title" v-html="contentNotice.title"></div>
            <div class="info">
              <span>작성자: {{ contentNotice.author }} </span>
              <span> {{ contentNotice.created_at }} </span>
            </div>
          </div>
          <div class="contents_area">
            <!-- <pre id="description"> {{ contentNotice.description }} </pre> -->
            <pre id="description" v-html="unescapeHtml(contentNotice.description)"></pre>
          </div>

          <div class="page_move">
            <div class="border_line"></div>
            <table v-if="contentNotice.attachments">
              <colgroup>
                <col width="100px" />
                <col width="100px" />
                <col width="50%" />
                <col width="200px" />
                <col width="200px" />
              </colgroup>
              <thead>
                <tr>
                  <th class="bold">첨부파일</th>
                  <td colspan="4">
                    <div class="pointer">{{ contentNotice.attachments }}</div>
                  </td>
                </tr>
              </thead>
            </table>
          </div>
          <div class="more_list">
            <button type="button" @click="back()">뒤로가기</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { ref, onMounted, getCurrentInstance } from 'vue';
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { loadDetailContentNoticeId } from '../api/boards'
// eslint-disable-next-line import/no-cycle
import router from '../router/router'

export default {
  name: 'ContentNoticeDetailViews',
  setup() {
    // const router = getCurrentInstance().proxy.$router;
    const route = useRoute()

    const contentsId = ref(null)
    const noticeId = ref(null)
    const contentNotice = ref([])

    const getData = async () => {
      contentsId.value = route.params.contentsId
      noticeId.value = route.params.noticeId

      const response = await loadDetailContentNoticeId(
        contentsId.value,
        noticeId.value
      )
      // console.log(response.data);
      contentNotice.value = response.data.content
      // console.log(contentNotice);
    }
    const back = () => {
      router.go(-1)
    }
    const unescapeHtml = (escapedHtml) => {
      const temp = document.createElement('div')
      temp.innerHTML = escapedHtml
      return temp.innerText || temp.textContent
    }

    onMounted(() => {
      getData()
    })
    return {
      contentNotice,
      getData,
      back,
      unescapeHtml,
    }
  },
}
</script>
